const isTablet = () => window.innerWidth < 768;

export default isTablet;
